import { Directive, TemplateRef } from '@angular/core';

@Directive({
	selector: 'ng-template[aePgtControlCustom]',
})
export class PaginationTableControlsCustomDirective {
	constructor(public template: TemplateRef<any>) {}
}
